<template>
    <div>
        <div v-if="erro">
            <SemPermissao></SemPermissao>
        </div>
        <template v-if="!erro">
            <CargoForm :cargo="null" />
        </template>
    </div>
</template>

<script>
    import CargoForm from '../../components/cargos/CargoForm.vue';
    import SemPermissao from "../SemPermissao.vue"
    
    //import ErroResultados from "../../components/ErroResultados";

    export default {
        name: "CargoNew",
        data() {
            return {
                erro: false,
            };
        },
        components: {
            SemPermissao,
            //ErroResultados,
            CargoForm,
        },
    };
</script>

<style lang="scss" scoped>
</style>